module.exports = __webpack_public_path__ + "static/logistic-blog-img-1-37bb7bc37897f1bb8e4a3845508faced.jpg";